import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createRole',
    serviceName: 'admin',
    query: gql`
      mutation createRole($title: String!, $name: String!) {
        createRole(title: $title, name: $name) {
          messages
        }
      }
    `,
  },
};

export default schema;
